export default {
  'ar-AE': {
    deselectedItem: '{item} غير المحدد',
    longPressToSelect: 'اضغط مطولًا للدخول إلى وضع التحديد.',
    select: 'تحديد',
    selectedAll: 'جميع العناصر المحددة.',
    selectedCount:
      '{count, plural, =0 {لم يتم تحديد عناصر} one {# عنصر محدد} other {# عنصر محدد}}.',
    selectedItem: '{item} المحدد',
  },
  'bg-BG': {
    deselectedItem: '{item} не е избран.',
    longPressToSelect:
      'Натиснете и задръжте за да влезете в избирателен режим.',
    select: 'Изберете',
    selectedAll: 'Всички елементи са избрани.',
    selectedCount:
      '{count, plural, =0 {Няма избрани елементи} one {# избран елемент} other {# избрани елементи}}.',
    selectedItem: '{item} избран.',
  },
  'cs-CZ': {
    deselectedItem: 'Položka {item} není vybrána.',
    longPressToSelect: 'Dlouhým stisknutím přejdete do režimu výběru.',
    select: 'Vybrat',
    selectedAll: 'Vybrány všechny položky.',
    selectedCount:
      '{count, plural, =0 {Nevybrány žádné položky} one {Vybrána # položka} other {Vybráno # položek}}.',
    selectedItem: 'Vybrána položka {item}.',
  },
  'da-DK': {
    deselectedItem: '{item} ikke valgt.',
    longPressToSelect: 'Lav et langt tryk for at aktivere valgtilstand.',
    select: 'Vælg',
    selectedAll: 'Alle elementer valgt.',
    selectedCount:
      '{count, plural, =0 {Ingen elementer valgt} one {# element valgt} other {# elementer valgt}}.',
    selectedItem: '{item} valgt.',
  },
  'de-DE': {
    deselectedItem: '{item} nicht ausgewählt.',
    longPressToSelect: 'Gedrückt halten, um Auswahlmodus zu öffnen.',
    select: 'Auswählen',
    selectedAll: 'Alle Elemente ausgewählt.',
    selectedCount:
      '{count, plural, =0 {Keine Elemente ausgewählt} one {# Element ausgewählt} other {# Elemente ausgewählt}}.',
    selectedItem: '{item} ausgewählt.',
  },
  'el-GR': {
    deselectedItem: 'Δεν επιλέχθηκε το στοιχείο {item}.',
    longPressToSelect:
      'Πατήστε παρατεταμένα για να μπείτε σε λειτουργία επιλογής.',
    select: 'Επιλογή',
    selectedAll: 'Επιλέχθηκαν όλα τα στοιχεία.',
    selectedCount:
      '{count, plural, =0 {Δεν επιλέχθηκαν στοιχεία} one {Επιλέχθηκε # στοιχείο} other {Επιλέχθηκαν # στοιχεία}}.',
    selectedItem: 'Επιλέχθηκε το στοιχείο {item}.',
  },
  'en-US': {
    deselectedItem: '{item} not selected.',
    select: 'Select',
    selectedCount:
      '{count, plural, =0 {No items selected} one {# item selected} other {# items selected}}.',
    selectedAll: 'All items selected.',
    selectedItem: '{item} selected.',
    longPressToSelect: 'Long press to enter selection mode.',
  },
  'es-ES': {
    deselectedItem: '{item} no seleccionado.',
    longPressToSelect: 'Mantenga pulsado para abrir el modo de selección.',
    select: 'Seleccionar',
    selectedAll: 'Todos los elementos seleccionados.',
    selectedCount:
      '{count, plural, =0 {Ningún elemento seleccionado} one {# elemento seleccionado} other {# elementos seleccionados}}.',
    selectedItem: '{item} seleccionado.',
  },
  'et-EE': {
    deselectedItem: '{item} pole valitud.',
    longPressToSelect: 'Valikurežiimi sisenemiseks vajutage pikalt.',
    select: 'Vali',
    selectedAll: 'Kõik üksused valitud.',
    selectedCount:
      '{count, plural, =0 {Üksusi pole valitud} one {# üksus valitud} other {# üksust valitud}}.',
    selectedItem: '{item} valitud.',
  },
  'fi-FI': {
    deselectedItem: 'Kohdetta {item} ei valittu.',
    longPressToSelect: 'Siirry valintatilaan painamalla pitkään.',
    select: 'Valitse',
    selectedAll: 'Kaikki kohteet valittu.',
    selectedCount:
      '{count, plural, =0 {Ei yhtään kohdetta valittu} one {# kohde valittu} other {# kohdetta valittu}}.',
    selectedItem: '{item} valittu.',
  },
  'fr-FR': {
    deselectedItem: '{item} non sélectionné.',
    longPressToSelect:
      'Appuyez de manière prolongée pour passer en mode de sélection.',
    select: 'Sélectionner',
    selectedAll: 'Tous les éléments sélectionnés.',
    selectedCount:
      '{count, plural, =0 {Aucun élément sélectionné} one {# élément sélectionné} other {# éléments sélectionnés}}.',
    selectedItem: '{item} sélectionné.',
  },
  'he-IL': {
    deselectedItem: '{item} לא נבחר.',
    longPressToSelect: 'הקשה ארוכה לכניסה למצב בחירה.',
    select: 'בחר',
    selectedAll: 'כל הפריטים נבחרו.',
    selectedCount:
      '{count, plural, =0 {לא נבחרו פריטים} one {פריט # נבחר} other {# פריטים נבחרו}}.',
    selectedItem: '{item} נבחר.',
  },
  'hr-HR': {
    deselectedItem: 'Stavka {item} nije odabrana.',
    longPressToSelect: 'Dugo pritisnite za ulazak u način odabira.',
    select: 'Odaberite',
    selectedAll: 'Odabrane su sve stavke.',
    selectedCount:
      '{count, plural, =0 {Nije odabrana nijedna stavka} one {Odabrana je # stavka} other {Odabrano je # stavki}}.',
    selectedItem: 'Stavka {item} je odabrana.',
  },
  'hu-HU': {
    deselectedItem: '{item} nincs kijelölve.',
    longPressToSelect: 'Nyomja hosszan a kijelöléshez.',
    select: 'Kijelölés',
    selectedAll: 'Az összes elem kijelölve.',
    selectedCount:
      '{count, plural, =0 {Egy elem sincs kijelölve} one {# elem kijelölve} other {# elem kijelölve}}.',
    selectedItem: '{item} kijelölve.',
  },
  'it-IT': {
    deselectedItem: '{item} non selezionato.',
    longPressToSelect: 'Premi a lungo per passare alla modalità di selezione.',
    select: 'Seleziona',
    selectedAll: 'Tutti gli elementi selezionati.',
    selectedCount:
      '{count, plural, =0 {Nessun elemento selezionato} one {# elemento selezionato} other {# elementi selezionati}}.',
    selectedItem: '{item} selezionato.',
  },
  'ja-JP': {
    deselectedItem: '{item} が選択されていません。',
    longPressToSelect: '長押しして選択モードを開きます。',
    select: '選択',
    selectedAll: 'すべての項目を選択しました。',
    selectedCount:
      '{count, plural, =0 {項目が選択されていません} one {# 項目を選択しました} other {# 項目を選択しました}}。',
    selectedItem: '{item} を選択しました。',
  },
  'ko-KR': {
    deselectedItem: '{item}이(가) 선택되지 않았습니다.',
    longPressToSelect: '선택 모드로 들어가려면 길게 누르십시오.',
    select: '선택',
    selectedAll: '모든 항목이 선택되었습니다.',
    selectedCount:
      '{count, plural, =0 {선택된 항목이 없습니다} one {#개 항목이 선택되었습니다} other {#개 항목이 선택되었습니다}}.',
    selectedItem: '{item}이(가) 선택되었습니다.',
  },
  'lt-LT': {
    deselectedItem: '{item} nepasirinkta.',
    longPressToSelect:
      'Norėdami įjungti pasirinkimo režimą, paspauskite ir palaikykite.',
    select: 'Pasirinkti',
    selectedAll: 'Pasirinkti visi elementai.',
    selectedCount:
      '{count, plural, =0 {Nepasirinktas nė vienas elementas} one {Pasirinktas # elementas} other {Pasirinkta elementų: #}}.',
    selectedItem: 'Pasirinkta: {item}.',
  },
  'lv-LV': {
    deselectedItem: 'Vienums {item} nav atlasīts.',
    longPressToSelect: 'Ilgi turiet nospiestu. lai ieslēgtu atlases režīmu.',
    select: 'Atlasīt',
    selectedAll: 'Atlasīti visi vienumi.',
    selectedCount:
      '{count, plural, =0 {Nav atlasīts neviens vienums} one {Atlasīto vienumu skaits: #} other {Atlasīto vienumu skaits: #}}.',
    selectedItem: 'Atlasīts vienums {item}.',
  },
  'nb-NO': {
    deselectedItem: '{item} er ikke valgt.',
    longPressToSelect: 'Bruk et langt trykk for å gå inn i valgmodus.',
    select: 'Velg',
    selectedAll: 'Alle elementer er valgt.',
    selectedCount:
      '{count, plural, =0 {Ingen elementer er valgt} one {# element er valgt} other {# elementer er valgt}}.',
    selectedItem: '{item} er valgt.',
  },
  'nl-NL': {
    deselectedItem: '{item} niet geselecteerd.',
    longPressToSelect: 'Druk lang om de selectiemodus te openen.',
    select: 'Selecteren',
    selectedAll: 'Alle items geselecteerd.',
    selectedCount:
      '{count, plural, =0 {Geen items geselecteerd} one {# item geselecteerd} other {# items geselecteerd}}.',
    selectedItem: '{item} geselecteerd.',
  },
  'pl-PL': {
    deselectedItem: 'Nie zaznaczono {item}.',
    longPressToSelect: 'Naciśnij i przytrzymaj, aby wejść do trybu wyboru.',
    select: 'Zaznacz',
    selectedAll: 'Wszystkie zaznaczone elementy.',
    selectedCount:
      '{count, plural, =0 {Nie zaznaczono żadnych elementów} one {# zaznaczony element} other {# zaznaczonych elementów}}.',
    selectedItem: 'Zaznaczono {item}.',
  },
  'pt-BR': {
    deselectedItem: '{item} não selecionado.',
    longPressToSelect: 'Mantenha pressionado para entrar no modo de seleção.',
    select: 'Selecionar',
    selectedAll: 'Todos os itens selecionados.',
    selectedCount:
      '{count, plural, =0 {Nenhum item selecionado} one {# item selecionado} other {# itens selecionados}}.',
    selectedItem: '{item} selecionado.',
  },
  'pt-PT': {
    deselectedItem: '{item} não selecionado.',
    longPressToSelect: 'Prima continuamente para entrar no modo de seleção.',
    select: 'Selecionar',
    selectedAll: 'Todos os itens selecionados.',
    selectedCount:
      '{count, plural, =0 {Nenhum item selecionado} one {# item selecionado} other {# itens selecionados}}.',
    selectedItem: '{item} selecionado.',
  },
  'ro-RO': {
    deselectedItem: '{item} neselectat.',
    longPressToSelect: 'Apăsați lung pentru a intra în modul de selectare.',
    select: 'Selectare',
    selectedAll: 'Toate elementele selectate.',
    selectedCount:
      '{count, plural, =0 {Niciun element selectat} one {# element selectat} other {# elemente selectate}}.',
    selectedItem: '{item} selectat.',
  },
  'ru-RU': {
    deselectedItem: '{item} не выбрано.',
    longPressToSelect: 'Нажмите и удерживайте для входа в режим выбора.',
    select: 'Выбрать',
    selectedAll: 'Выбраны все элементы.',
    selectedCount:
      '{count, plural, =0 {Нет выбранных элементов} one {# элемент выбран} other {# элементов выбрано}}.',
    selectedItem: '{item} выбрано.',
  },
  'sk-SK': {
    deselectedItem: 'Nevybraté položky: {item}.',
    longPressToSelect: 'Dlhším stlačením prejdite do režimu výberu.',
    select: 'Vybrať',
    selectedAll: 'Všetky vybraté položky.',
    selectedCount:
      '{count, plural, =0 {Žiadne vybraté položky} one {# vybratá položka} other {Počet vybratých položiek:#}}.',
    selectedItem: 'Vybraté položky: {item}.',
  },
  'sl-SI': {
    deselectedItem: 'Element {item} ni izbran.',
    longPressToSelect: 'Za izbirni način pritisnite in dlje časa držite.',
    select: 'Izberite',
    selectedAll: 'Vsi elementi so izbrani.',
    selectedCount:
      '{count, plural, =0 {Noben element ni izbran} one {# element je izbran} other {# elementov je izbranih}}.',
    selectedItem: 'Element {item} je izbran.',
  },
  'sr-SP': {
    deselectedItem: '{item} nije izabrano.',
    longPressToSelect: 'Dugo pritisnite za ulazak u režim biranja.',
    select: 'Izaberite',
    selectedAll: 'Izabrane su sve stavke.',
    selectedCount:
      '{count, plural, =0 {Nije izabrana nijedna stavka} one {Izabrana je # stavka} other {Izabrano je # stavki}}.',
    selectedItem: '{item} je izabrano.',
  },
  'sv-SE': {
    deselectedItem: '{item} ej markerat.',
    longPressToSelect: 'Tryck länge när du vill öppna väljarläge.',
    select: 'Markera',
    selectedAll: 'Alla markerade objekt.',
    selectedCount:
      '{count, plural, =0 {Inga markerade objekt} one {# markerat objekt} other {# markerade objekt}}.',
    selectedItem: '{item} markerat.',
  },
  'tr-TR': {
    deselectedItem: '{item} seçilmedi.',
    longPressToSelect: 'Seçim moduna girmek için uzun basın.',
    select: 'Seç',
    selectedAll: 'Tüm ögeler seçildi.',
    selectedCount:
      '{count, plural, =0 {Hiçbir öge seçilmedi} one {# öge seçildi} other {# öge seçildi}}.',
    selectedItem: '{item} seçildi.',
  },
  'uk-UA': {
    deselectedItem: '{item} не вибрано.',
    longPressToSelect:
      'Виконайте довге натиснення, щоб перейти в режим вибору.',
    select: 'Вибрати',
    selectedAll: 'Усі елементи вибрано.',
    selectedCount:
      '{count, plural, =0 {Жодних елементів не вибрано} one {# елемент вибрано} other {Вибрано елементів: #}}.',
    selectedItem: '{item} вибрано.',
  },
  'zh-CN': {
    deselectedItem: '未选择 {item}。',
    longPressToSelect: '长按以进入选择模式。',
    select: '选择',
    selectedAll: '已选择所有项目。',
    selectedCount:
      '{count, plural, =0 {未选择项目} one {已选择 # 个项目} other {已选择 # 个项目}}。',
    selectedItem: '已选择 {item}。',
  },
  'zh-TW': {
    deselectedItem: '未選取「{item}」。',
    longPressToSelect: '長按以進入選擇模式。',
    select: '選取',
    selectedAll: '已選取所有項目。',
    selectedCount:
      '{count, plural, =0 {未選取任何項目} one {已選取 # 個項目} other {已選取 # 個項目}}。',
    selectedItem: '已選取「{item}」。',
  },
};
